import { render, staticRenderFns } from "./EnterTips.vue?vue&type=template&id=3664c5d6&scoped=true&"
import script from "./EnterTips.vue?vue&type=script&lang=js&"
export * from "./EnterTips.vue?vue&type=script&lang=js&"
import style0 from "./EnterTips.vue?vue&type=style&index=0&id=3664c5d6&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3664c5d6",
  null
  
)

export default component.exports